import { TSort, TSortAmplitude } from 'context/reducers/truckers.type';

export interface SortFilter {
  checked: string;
  setChecked: (value: string | null) => void;
}

export type TSortList = {
  label: string;
  value: TSort;
  amplitudePropertyName: TSortAmplitude;
  checked: string;
};

export const VALUES: TSortList[] = [
  {
    label: 'Proximidade da carga',
    value: 'distance',
    amplitudePropertyName: 'cargo-proximity',
    checked: 'Proximidade',
  },
  {
    label: 'Localização mais recente',
    value: 'dateLastLocation',
    amplitudePropertyName: 'recent-location',
    checked: 'Localização',
  },
];
